<template>
  <div id="addstep" class="pb30">
    <Breadcrumb />
    <div class="font14">
      <p class="sub-title prl70 mt20">Configuration</p>
      <div class="content middle collect mb50">
        <div class="container configuration">
          <div class="row">
            <div class="col-xs-2">Artwork Name</div>
            <div class="col-xs-4">
              <el-input
                v-model="$store.state.artwork.name"
                placeholder
              ></el-input>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-2">Communication Protocol</div>
            <div class="col-xs-4">
              <el-radio
                v-model="$store.state.artwork.protocol"
                v-for="item in protocols"
                :key="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
            </div>
          </div>
          <div class="row" v-show="showProductLine">
            <div class="col-xs-2">Product Line</div>
            <div class="col-xs-6">
              <el-radio
                v-model="productLine"
                v-for="item in productLines"
                :key="item.value"
                :value="item.value"
                :label="item.value"
              >
                {{ item.label }}
              </el-radio>
              <span v-if="productLine == 'Classic'"
                >* No Sensors</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-footer white font16">
      <span class="white click inlineb w10" @click="restart()">
        <i class="iconfont3 icon-reset"></i> RESTART
      </span>
      <span class="white click inlineb w10" @click="back()">
        <i class="iconfont3 icon-back"></i> BACK
      </span>

      <span class="orange click inlineb w10" @click="next()">
        NEXT <i class="iconfont3 icon-next"></i>
      </span>
    </div>
  </div>
</template>

<script>
import "@/assets/css/project.css";
import artworkToProductMixin from "../../mixins/artworkToProductMixin";
import Breadcrumb from "./Panel/Breadcrumb";

var productLines = [
  {
    label: "Signature",
    value: "Signature",
  },
  {
    label: "Classic (*)",
    value: "Classic",
  },
];

export default {
  name: "s7",
  mixins: [artworkToProductMixin],
  components: {
    Breadcrumb,
  },
  data() {
    return { 
      productLine: null,
      protocols: [
        {
          label: "Crestron",
          value: "Crestron",
        },
        {
          label: "KNX",
          value: "KNX",
        },
        {
          label: "RS485",
          value: "RS485",
        },
      ],
    };
  },
  methods: {
    restart() {
      this.$confirm("Are you sure you want to restart?", "Warning", {
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.$router.push({ path: "/collection" });
      });
    },
    back() {
      this.$store.commit("getProductCode");
      this.$router.push({
        path: "/collection/engraving/" + this.routeParamArtworkId,
      });
    },
    async next() {
      if (this.$store.state.artwork.protocol == "") {
        this.$message({
          type: "error",
          message: "Please Select Communication Protocol",
        });
        return;
      }
      this.$store.commit("getProductCode");
      this.$router.push({
        path: "/collection/preview/" + this.routeParamArtworkId,
      });
    },
  },
  computed: {
    productLines() {
      let types = ['alba', 'aria', 'axes'];
      if (this.$store.state.artwork.type == 'blackjack') {
        return (this.$store.state.artwork.frameColor.startsWith('mj')) ? [
            productLines[0],
          ] : [productLines[1]];
      } else if (types.includes(this.$store.state.artwork.type) && (this.$store.state.artwork.frameColor == "gb" || this.$store.state.artwork.frameColor == "gw")) {
        return productLines;
      } else if (this.$store.state.artwork.type == 'alba' && this.$store.state.artwork.frameColor.startsWith("ma") && (this.$store.state.artwork.keyColor == "gb" || this.$store.state.artwork.keyColor == "gw")) {
        return productLines;
      } else {
        return [productLines[1]];
      }
        
    },
    showProductLine() {
      if (this.productLines.length > 1) {
        return true;
      }
      return false;
    },
  },
  watch: {
    productLines: {
      immediate: true,
      handler(newVal) {
        if (newVal.length == 1) {
          this.$store.state.artwork.productLine = newVal[0].value;
        }
      },
    },
    productLine(newVal) {
      this.$store.state.artwork.productLine = newVal
    }
  },
  mounted() {
    if (typeof this.$store.state.artwork.productLine == 'undefined') {
      let classic = this.productLines.find((productLine) => productLine.value == 'Classic')
      if (classic) {
        this.productLine = classic.value
      } else {
        this.productLine = this.productLines[0].value;
      }
    } else {
      this.productLine = this.$store.state.artwork.productLine
    }
  },
  created: function () {
    if (!this.$store.state.artwork.type) {
      alert("Please go to the start page");
      this.$router.push({ path: "/collection/" });
    }

    this.$parent.headerB();
    this.$parent.footerB();
    this.$parent.footerW();
    this.$store.state.current_step = 7;
  },
};
</script>

<style lang="css" scoped>
.nav-footer {
  border-top: 1px solid #ccc;
}
</style>
